
<div
  id="pageCasino"
  class="d-flex flex-column main-casino"
  :class="{ 'h-100': !isHauteurPageAutomatique }"
>
  <div :class="[content.theme, getStatusMenuGauche ? 'menu-ouvert' : 'menu-ferme']">
    <vue-headful
      :title="metaData.title"
      :description="metaData.description"
      :keywords="metaData.keywords"
      :image="metaData.metaOGImage"
      :url="metaUrl"
      :head="{
        'meta[name=robots]': { content: metaData.metaNoIndex },
        'link[hreflang=en-ca]': { href: pathAnglais },
        'link[hreflang=fr-ca]': { href: pathFrancais },
        'link[rel=apple-touch-icon]': { type: 'image/png' },
        'link[rel=icon]': { type: 'image/png' },
      }"
    />

    <!-- Ces 2 spans évitent erreur dans barreconnect-app.js -->
    <!-- TODO: À corriger dans lq-entete-connexion -->
    <!-- TODO: 2021-11-10 à détruire? Conserver cette ligne cause un doublon au niveau des id de la page. -->
    <!-- <span id="mel-topNotif"></span><span id="mel-notif"></span> -->

    <div
      class="w-100 h-100 d-flex align-items-start"
      :class="
        content.theme == 'casinoClair'
          ? 'themeClair'
          : { themeFonce: content.theme == 'casinoFonce' }
      "
    >
      <Heritage
        v-if="content.themeMenu !== 'invisible'"
        :key="componentKey"
        class="d-none d-lg-flex px-0 navbar-gauche position-sticky vh-100"
        :content="contentHeritageMenuGauche"
      />
      <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
        <EditableArea
          v-if="content.main"
          :key="componentKey"
          class="w-100 h-100"
          :content="content.main"
        />
        <IframeHtmlSalesforce
          v-if="isAfficherClavardage"
          :positionBulle="content.positionBulle"
        />
      </main>
      <Heritage :content="contentHeritageModalNewsletter" />
    </div>

    <Heritage
      v-if="content.themeMenu !== 'invisible' && isMenuBasVisible"
      :key="componentKey"
      class="navbar-bas d-lg-none"
      :content="contentHeritageMenuBas"
    />
    <footer
      v-if="isPiedDePageVisible"
      id="footer"
      class="p-0"
      :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
    >
      <Heritage :key="componentKey" class="piedDePage" :content="contentHeritage" />
    </footer>
  </div>
</div>
